import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError, LOGO_URL } from "@/lib/api";
import { Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@onehospitals.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, admin!");
      nav("/admin");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Login failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center p-4 relative overflow-hidden hero-bg" data-testid="admin-login-page">
      <div className="orb" style={{ width: 360, height: 360, background: "#d946ef", top: -100, left: -100 }} />
      <div className="orb" style={{ width: 400, height: 400, background: "#10f77f", bottom: -120, right: -120, animationDelay: "-5s", opacity: 0.3 }} />
      <form onSubmit={submit} className="card-3d w-full max-w-md p-8 relative z-10">
        <div className="flex items-center gap-3 mb-7">
          <div className="logo-badge"><img src={LOGO_URL} alt="One Hospitals" className="h-12 w-12 object-contain" /></div>
          <div>
            <div className="font-serif font-bold text-lg text-cream">Admin Console</div>
            <div className="text-xs text-mute font-mono">one hospitals</div>
          </div>
        </div>
        <h1 className="text-3xl font-serif font-bold flex items-center gap-2 text-cream"><Lock className="h-5 w-5 text-brand-purple" /> Sign in</h1>
        <p className="text-sm text-mute mt-1">Enter your admin credentials to continue.</p>
        <div className="mt-7 space-y-4">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Admin email" required data-testid="admin-email-input" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required data-testid="admin-password-input" />
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-login-submit">{loading ? "Signing in…" : <>Sign In <ArrowRight className="h-4 w-4" /></>}</button>
        </div>
      </form>
    </div>
  );
}
